import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../common/hooks/useAuth";
import { CircularProgress, Box, Typography, Snackbar, Alert } from "@mui/material";
import { useAxios } from "../../../common/api/hooks/useAxios";
import { URL } from "../../../common/api/urls";
import { SNACKBAR_AUTO_HIDE_DURATION, TEXT_MSGS } from '../../../common/utility/constant';
import AppErrorPopup from '../../../components/AppErrorPopup';
import { getLoginFingerprintPayload } from '../../../common/utility/deviceFingerprint';
import { notifyInvalidatedSessions } from '../../../common/api/hooks/useAxiosPrivate';


export default function GoogleCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname && location.state?.from?.search?location.state?.from?.pathname +location.state?.from?.search: "/";
  const { setAuth } = useAuth();
  const [msgState, setMsgState] = useState({
    open: false,
    msg: "",
    severity: ""
  })

  const { open, msg, severity} = msgState

  const {
    cancel: googleCallbackCancel, 
    responseData: googleCallbackResponseData, 
    error: googleCallbackError, 
    loaded: googleCallbackLoaded, 
    reset: googleCallbackReset, 
    executeAPI: googleCallbackExecuteAPI
  } = useAxios()

  const callbackStartedRef = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (!code || callbackStartedRef.current) return;
    callbackStartedRef.current = true;

    (async () => {
      const fingerprint = await getLoginFingerprintPayload();
      googleCallbackExecuteAPI(URL.GOOGLE_CALLBACK_URL, "POST", {
        code,
        state,
        fingerprint,
      });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (googleCallbackLoaded){
      if(googleCallbackResponseData != null){
        setAuth({
          accessToken: googleCallbackResponseData.token,
          name: `${googleCallbackResponseData.first_name} ${googleCallbackResponseData.last_name}`,
          role: googleCallbackResponseData.role,
          resources: googleCallbackResponseData.resources,
          email_id: googleCallbackResponseData.email_id,
          demo: googleCallbackResponseData.demo,
          tos_notify: !!googleCallbackResponseData.tos_notify,
          contact_verify_notify: !!googleCallbackResponseData.contact_verify_notify,
          handoff: googleCallbackResponseData.handoff,
        });

        const invalidated = googleCallbackResponseData.invalidated_sessions;
        if (Array.isArray(invalidated) && invalidated.length > 0) {
          notifyInvalidatedSessions(invalidated);
        }

        navigate(from, { replace: true });
      }
      else if(googleCallbackError!=null){
        setMsgState({open:true,msg:`${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        googleCallbackReset();
      }
    }
  }, [googleCallbackLoaded, googleCallbackResponseData]);

    const handleClose = (event, reason) => {
      setMsgState({...msgState,open:false});
  };



  // Return Dummy UI loading UI while processing (NEED TO BE CHANGED)
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Completing Google Sign-In...
      </Typography>

      <AppErrorPopup
        open={open}
        message={msg}
        severity={severity}
        onClose={handleClose}
        showCloseX
      />
      {/* Legacy snackbar (replaced by AppErrorPopup)
      <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}} sx={{top:"48px"}} open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} >
        <Alert  severity={severity} sx={{ width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
          {msg}
        </Alert>  
    </Snackbar>
    */}
    </Box>
  );
}